__turbopack_context__.v({
  "ol": "list-module-scss-module__qnqlxa__ol",
  "ul": "list-module-scss-module__qnqlxa__ul",
});
